<template>
  <div class="highlight-card__film">
    <img
      alt=""
      class="highlight-card__film-image"
      decoding="async"
      loading="lazy"
      v-if="image"
      :src="image"
    >
    <!-- The whole picture plays the film, as the section's poster does. -->
    <button
      class="highlight-card__film-open"
      tabindex="-1"
      type="button"
      :aria-label="label || text"
      @click="emit('play')"
    />
    <life-story-pill
      class="highlight-card__film-pill"
      large
      :label="label"
      :text="text"
      @click="emit('play')"
    />
  </div>
</template>

<script lang="ts" setup>
  import LifeStoryPill from "Plugins/obituary/javascript/components/Slideshow/LifeStoryPill.vue";

  /** A film's first frame, standing still until the pill is pressed: never autoplays. */
  defineProps<{ image: string | null; label?: string; text: string }>();

  const emit = defineEmits<{ play: [] }>();
</script>
